import React, { useState, useRef, useEffect } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import styles from "./index.module.scss";
import { useModel } from "hooks/useModel";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ChatList from "../ChatList/ChatList";

const NavButtonGroup = (props: any) => {
  const {
    promptsOpen,
    setPromptsOpen,
    fullScreen,
    setFullScreen,
    selectedKey,
    setSelectKey,
    promptConfig,
    setPromptConfig,
  } = useModel("aichat");
  const [showHistory, setShowHistory] = useState(false);
  const historyRef = useRef<HTMLDivElement | null>(null);
  const historyButtonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const isInPortal = target.closest(".MuiPopover-root, .MuiPopper-root");
      if (
        showHistory &&
        historyRef.current &&
        !historyRef.current.contains(target) &&
        historyButtonRef.current &&
        !historyButtonRef.current.contains(target) &&
        !isInPortal
      ) {
        setShowHistory(false);
      }
    };
    if (showHistory) {
      document.addEventListener("mouseup", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mouseup", handleClickOutside);
    };
  }, [showHistory]);

  return (
    <>
      <Box className={styles.operate}>
        <Tooltip title="New Chat">
          <IconButton
            ref={historyButtonRef}
            onClick={() => {
              if (selectedKey) setSelectKey(null);
            }}
          >
            <img
              src={selectedKey ? "/aichat/newchat.svg" : "/aichat/newchatDisabled.svg"}
              alt=""
            />
          </IconButton>
        </Tooltip>
        {!fullScreen && (
          <>
            <Tooltip title="History">
              <IconButton
                ref={historyButtonRef}
                onClick={() => setShowHistory(!showHistory)}
              >
                <img
                  src={showHistory ? "/aichat/historyactive.svg" : "/aichat/history.svg"}
                  alt=""
                />
              </IconButton>
            </Tooltip>
          </>
        )}
        <Tooltip title="Prompts">
          <IconButton
            onClick={() => {
              if (!promptsOpen) setFullScreen(true);
              setPromptsOpen(!promptsOpen);
              if (promptConfig.state !== "close") {
                setPromptConfig({
                  state: "close",
                  favorite: true,
                  promptContent: "",
                  promptDescription: "",
                  promptIcon: "lightbulb",
                  promptTitle: "",
                  promptType: "personal",
                  promptVisibility: "public",
                  id: null,
                });
              }
            }}
          >
            <img
              src="/aichat/prompts.svg"
              alt=""
            />
          </IconButton>
        </Tooltip>
        {fullScreen ? (
          <Tooltip title="Exit Full Screen">
            <IconButton onClick={() => setFullScreen(false)}>
              <img
                src="/aichat/fullscreenExit.svg"
                alt=""
              />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Full Screen">
            <IconButton onClick={() => setFullScreen(true)}>
              <img
                src="/aichat/fullscreen.svg"
                alt=""
              />
            </IconButton>
          </Tooltip>
        )}
        <IconButton onClick={() => props.onClose()}>
          <CloseOutlinedIcon fontSize="small" />
        </IconButton>
      </Box>

      {showHistory && !fullScreen && (
        <Box
          className={styles.chatListHistory}
          ref={historyRef}
        >
          <ChatList hide={true} />
        </Box>
      )}
    </>
  );
};

export default NavButtonGroup;
